module.exports = __webpack_public_path__ + "img/shixiangyuan.442c3319.png";